import { render, staticRenderFns } from "./ApexAreaChart.vue?vue&type=template&id=489fab91&"
import script from "./ApexAreaChart.vue?vue&type=script&lang=js&"
export * from "./ApexAreaChart.vue?vue&type=script&lang=js&"
import style0 from "./ApexAreaChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports